var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClouddata(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.793 28.115h22.895c2.1 0 3.812-1.747 3.812-3.91 0-2.16-1.714-3.909-3.812-3.909-.593 0-1.16.138-1.678.403l-.861.437.14-.955c.006-.044.01-.09.012-.143.003-.059.004-.109.004-.23 0-4.594-3.632-8.308-8.114-8.308-2.457 0-4.737 1.128-6.272 3.039l-.28.348-.377-.239a3.122 3.122 0 00-1.684-.486c-1.808 0-3.285 1.51-3.285 3.371 0 .396.062.758.186 1.092l.31.832-.872-.166a2.09 2.09 0 00-.124-.004c-2.367 0-4.293 1.977-4.293 4.416 0 2.444 1.922 4.412 4.293 4.412z",
    stroke: "#000",
    fill: "#4D4D4D",
    fillRule: "evenodd",
    strokeOpacity: 0.15
  })));
}
export default __webpack_public_path__ + "static/assets/33b737193edfe1730f38112ad35a84b4.svg";
export { SvgClouddata as ReactComponent };